<template>
  <div
    ref="sidebarRef"
    :class="[
      'sidebar-area bg-white dark:bg-[#0c1427] fixed z-[8] top-0 h-screen transition-all rounded-r-md',
      { active: stateStoreInstance.open },
    ]"
  >
    <div
      class="logo bg-white dark:bg-[#0c1427] border-b border-gray-100 dark:border-[#172036] px-[25px] pt-[19px] pb-[15px] absolute z-[2] right-0 top-0 left-0"
    >
      <RouterLink
        to="/dashboard"
        class="transition-none relative flex items-center justify-center"
      >
        <img src="@/assets/images/logos/sidebarlogo.png" alt="logo" class="h-10" />
      </RouterLink>
      <button
        type="button"
        v-if="isMobile()"
        class="close-sidebar-btn inline-block absolute z-[10] top-[24px] ltr:right-[25px] rtl:left-[25px] transition-all hover:text-primary-500"
        @click="closeSidebar"
      >
        <i class="material-symbols-outlined !text-[22px]"> close </i>
      </button>
    </div>
    <div class="pt-[89px] px-[25px] pb-[20px] h-[calc(100vh-89px)] overflow-y-auto rounded-md">
      <div class="accordion">
        <span
          class="block relative font-medium uppercase text-gray-400 mb-[8px] text-xs"
          data-i18n-key="sidebar.main"
        >
          {{ directT('sidebar.main') }}
        </span>
        <div
          class="accordion-item rounded-md text-black dark:text-white mb-[5px] whitespace-nowrap"
        >
          <button
            class="accordion-button toggle flex items-center transition-all py-[9px] ltr:pl-[14px] ltr:pr-[30px] rtl:pr-[14px] rtl:pl-[30px] rounded-md font-medium w-full relative hover:bg-gray-50 text-left dark:hover:bg-[#15203c]"
            type="button"
          >
            <i
              class="material-symbols-outlined transition-all text-gray-500 dark:text-gray-400 ltr:mr-[7px] rtl:ml-[7px] !text-[22px] leading-none relative -top-px"
            >
              dashboard
            </i>
            <span class="title leading-none" data-i18n-key="sidebar.dashboards">{{ directT('sidebar.dashboards') }}</span>
          </button>
          <div class="accordion-collapse hidden">
            <div class="pt-[4px]">
              <ul class="sidebar-sub-menu">
                <li v-if="shouldShowEcommerceDashboard" class="sidemenu-item mb-[4px] last:mb-0">
                  <RouterLink
                    to="/dashboard"
                    class="sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]"
                    @click="handleNavigation"
                  >
                    <span data-i18n-key="sidebar.ecommerce">{{ directT('sidebar.ecommerce') }}</span>
                  </RouterLink>
                </li>
                <li v-if="shouldShowCRMDashboard" class="sidemenu-item mb-[4px] last:mb-0">
                  <RouterLink
                    to="/dashboard/crm"
                    class="sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]"
                    @click="handleNavigation"
                  >
                    <span data-i18n-key="sidebar.crm">{{ directT('sidebar.crm') }}</span>
                  </RouterLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <span
          class="block relative font-medium uppercase text-gray-400 mb-[8px] text-xs [&:not(:first-child)]:mt-[22px]"
          data-i18n-key="sidebar.apps"
        >
          {{ directT('sidebar.apps') }}
        </span>
        <div
          class="accordion-item rounded-md text-black dark:text-white mb-[5px] whitespace-nowrap"
        >
          <RouterLink
            to="/apps/to-do-list"
            class="accordion-button flex items-center transition-all py-[9px] ltr:pl-[14px] ltr:pr-[30px] rtl:pr-[14px] rtl:pl-[30px] rounded-md font-medium w-full relative hover:bg-gray-50 text-left dark:hover:bg-[#15203c]"
            @click="handleNavigation"
          >
            <i
              class="material-symbols-outlined transition-all text-gray-500 dark:text-gray-400 ltr:mr-[7px] rtl:ml-[7px] !text-[22px] leading-none relative -top-px"
            >
              format_list_bulleted
            </i>
            <span class="title leading-none" data-i18n-key="sidebar.todoList">{{ directT('sidebar.todoList') }}</span>
          </RouterLink>
        </div>
        <div
          class="accordion-item rounded-md text-black dark:text-white mb-[5px] whitespace-nowrap"
        >
          <RouterLink
            to="/apps/calendar"
            class="accordion-button flex items-center transition-all py-[9px] ltr:pl-[14px] ltr:pr-[30px] rtl:pr-[14px] rtl:pl-[30px] rounded-md font-medium w-full relative hover:bg-gray-50 text-left dark:hover:bg-[#15203c]"
            @click="handleNavigation"
          >
            <i
              class="material-symbols-outlined transition-all text-gray-500 dark:text-gray-400 ltr:mr-[7px] rtl:ml-[7px] !text-[22px] leading-none relative -top-px"
            >
              date_range
            </i>
            <span class="title leading-none" data-i18n-key="sidebar.calendar">{{ directT('sidebar.calendar') }}</span>
          </RouterLink>
        </div>
        <div
          class="accordion-item rounded-md text-black dark:text-white mb-[5px] whitespace-nowrap"
        >
          <RouterLink
            to="/apps/chat"
            class="accordion-button flex items-center transition-all py-[9px] ltr:pl-[14px] ltr:pr-[30px] rtl:pr-[14px] rtl:pl-[30px] rounded-md font-medium w-full relative hover:bg-gray-50 text-left dark:hover:bg-[#15203c]"
            @click="handleNavigation"
          >
            <i
              class="material-symbols-outlined transition-all text-gray-500 dark:text-gray-400 ltr:mr-[7px] rtl:ml-[7px] !text-[22px] leading-none relative -top-px"
            >
              chat
            </i>
            <span class="title leading-none" data-i18n-key="sidebar.chat">{{ directT('sidebar.chat') }}</span>
          </RouterLink>
        </div>
        <div
          class="accordion-item rounded-md text-black dark:text-white mb-[5px] whitespace-nowrap"
        >
          <RouterLink
            to="/apps/contacts"
            class="accordion-button flex items-center transition-all py-[9px] ltr:pl-[14px] ltr:pr-[30px] rtl:pr-[14px] rtl:pl-[30px] rounded-md font-medium w-full relative hover:bg-gray-50 text-left dark:hover:bg-[#15203c]"
            @click="handleNavigation"
          >
            <i
              class="material-symbols-outlined transition-all text-gray-500 dark:text-gray-400 ltr:mr-[7px] rtl:ml-[7px] !text-[22px] leading-none relative -top-px"
            >
              contacts
            </i>
            <span class="title leading-none" data-i18n-key="sidebar.contacts">{{ directT('sidebar.contacts') }}</span>
          </RouterLink>
        </div>
        <span
          class="block relative font-medium uppercase text-gray-400 mb-[8px] text-xs [&:not(:first-child)]:mt-[22px]"
          data-i18n-key="sidebar.pages"
        >
          {{ directT('sidebar.pages') }}
        </span>
        <div
          v-if="shouldShowEcommerceMenu"
          class="accordion-item rounded-md text-black dark:text-white mb-[5px] whitespace-nowrap"
        >
          <button
            class="accordion-button toggle flex items-center transition-all py-[9px] ltr:pl-[14px] ltr:pr-[30px] rtl:pr-[14px] rtl:pl-[30px] rounded-md font-medium w-full relative hover:bg-gray-50 text-left dark:hover:bg-[#15203c]"
            type="button"
          >
            <i
              class="material-symbols-outlined transition-all text-gray-500 dark:text-gray-400 ltr:mr-[7px] rtl:ml-[7px] !text-[22px] leading-none relative -top-px"
            >
              shopping_cart
            </i>
            <span class="title leading-none" data-i18n-key="sidebar.ecommerce">{{ directT('sidebar.ecommerce') }}</span>
          </button>
          <div class="accordion-collapse hidden">
            <div class="pt-[4px]">
              <ul class="sidebar-sub-menu">
                <li class="sidemenu-item mb-[4px] last:mb-0">
                  <RouterLink
                    to="/ecommerce/products-grid"
                    class="sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]"
                    @click="handleNavigation"
                  >
                    <span data-i18n-key="sidebar.productsGrid">{{ directT('sidebar.productsGrid') }}</span>
                  </RouterLink>
                </li>
                <li class="sidemenu-item mb-[4px] last:mb-0">
                  <RouterLink
                    to="/ecommerce/products-list"
                    class="sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]"
                    @click="handleNavigation"
                  >
                    <span data-i18n-key="sidebar.productsList">{{ directT('sidebar.productsList') }}</span>
                  </RouterLink>
                </li>
                <li class="sidemenu-item mb-[4px] last:mb-0">
                  <RouterLink
                    to="/crm/customers"
                    class="sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]"
                    @click="handleNavigation"
                  >
                    <span data-i18n-key="sidebar.customers">{{ directT('sidebar.customers') }}</span>
                  </RouterLink>
                </li>
                <li class="sidemenu-item mb-[4px] last:mb-0">
                  <RouterLink
                    to="/ecommerce/orders"
                    class="sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]"
                    @click="handleNavigation"
                  >
                    <span data-i18n-key="sidebar.orders">{{ directT('sidebar.orders') }}</span>
                  </RouterLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          v-if="shouldShowCRMMenu"
          class="accordion-item rounded-md text-black dark:text-white mb-[5px] whitespace-nowrap"
        >
          <button
            class="accordion-button toggle flex items-center transition-all py-[9px] ltr:pl-[14px] ltr:pr-[30px] rtl:pr-[14px] rtl:pl-[30px] rounded-md font-medium w-full relative hover:bg-gray-50 text-left dark:hover:bg-[#15203c]"
            type="button"
          >
            <i
              class="material-symbols-outlined transition-all text-gray-500 dark:text-gray-400 ltr:mr-[7px] rtl:ml-[7px] !text-[22px] leading-none relative -top-px"
            >
              business_chip
            </i>
            <span class="title leading-none" data-i18n-key="sidebar.crm">{{ directT('sidebar.crm') }}</span>
          </button>
          <div class="accordion-collapse hidden">
            <div class="pt-[4px]">
              <ul class="sidebar-sub-menu">
                <li class="sidemenu-item mb-[4px] last:mb-0">
                  <RouterLink
                    to="/crm/leads"
                    class="sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]"
                    @click="handleNavigation"
                  >
                    <span data-i18n-key="sidebar.leads">{{ directT('sidebar.leads') }}</span>
                  </RouterLink>
                </li>
                <li class="sidemenu-item mb-[4px] last:mb-0">
                  <RouterLink
                    to="/crm/customers"
                    class="sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]"
                    @click="handleNavigation"
                  >
                    <span data-i18n-key="sidebar.customers">{{ directT('sidebar.customers') }}</span>
                  </RouterLink>
                </li>
                <li class="sidemenu-item mb-[4px] last:mb-0">
                  <RouterLink
                    to="/crm/deals"
                    class="sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]"
                    @click="handleNavigation"
                  >
                    <span data-i18n-key="sidebar.deals">{{ directT('sidebar.deals') }}</span>
                  </RouterLink>
                </li>
                <li class="sidemenu-item mb-[4px] last:mb-0">
                  <RouterLink
                    to="/ecommerce/products-grid"
                    class="sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]"
                    @click="handleNavigation"
                  >
                    <span data-i18n-key="sidebar.productsGrid">{{ directT('sidebar.productsGrid') }}</span>
                  </RouterLink>
                </li>
                <li class="sidemenu-item mb-[4px] last:mb-0">
                  <RouterLink
                    to="/ecommerce/products-list"
                    class="sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]"
                    @click="handleNavigation"
                  >
                    <span data-i18n-key="sidebar.productsList">{{ directT('sidebar.productsList') }}</span>
                  </RouterLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          v-if="shouldShowRealEstateMenu"
          class="accordion-item rounded-md text-black dark:text-white mb-[5px] whitespace-nowrap"
        >
          <button
            class="accordion-button toggle flex items-center transition-all py-[9px] ltr:pl-[14px] ltr:pr-[30px] rtl:pr-[14px] rtl:pl-[30px] rounded-md font-medium w-full relative hover:bg-gray-50 text-left dark:hover:bg-[#15203c]"
            type="button"
          >
            <i
              class="material-symbols-outlined transition-all text-gray-500 dark:text-gray-400 ltr:mr-[7px] rtl:ml-[7px] !text-[22px] leading-none relative -top-px"
            >
              real_estate_agent
            </i>
            <span class="title leading-none" data-i18n-key="sidebar.realEstate">{{ directT('sidebar.realEstate') }}</span>
          </button>
          <div class="accordion-collapse hidden">
            <div class="pt-[4px]">
              <ul class="sidebar-sub-menu">
                <li class="sidemenu-item mb-[4px] last:mb-0">
                  <RouterLink
                    to="/real-estate/property-list"
                    class="sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]"
                    @click="handleNavigation"
                  >
                    <span data-i18n-key="sidebar.propertyList">{{ directT('sidebar.propertyList') }}</span>
                  </RouterLink>
                </li>
                <li class="sidemenu-item mb-[4px] last:mb-0">
                  <RouterLink
                    to="/real-estate/add-property"
                    class="sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]"
                    @click="handleNavigation"
                  >
                    <span data-i18n-key="sidebar.addProperty">{{ directT('sidebar.addProperty') }}</span>
                  </RouterLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <span
          class="block relative font-medium uppercase text-gray-400 mb-[8px] text-xs [&:not(:first-child)]:mt-[22px]"
          data-i18n-key="sidebar.others"
        >
          {{ directT('sidebar.others') }}
        </span>
        <div
          class="accordion-item rounded-md text-black dark:text-white mb-[5px] whitespace-nowrap"
        >
          <RouterLink
            to="/members"
            class="accordion-button flex items-center transition-all py-[9px] ltr:pl-[14px] ltr:pr-[30px] rtl:pr-[14px] rtl:pl-[30px] rounded-md font-medium w-full relative hover:bg-gray-50 text-left dark:hover:bg-[#15203c]"
            @click="handleNavigation"
          >
            <i
              class="material-symbols-outlined transition-all text-gray-500 dark:text-gray-400 ltr:mr-[7px] rtl:ml-[7px] !text-[22px] leading-none relative -top-px"
            >
              people
            </i>
            <span class="title leading-none" data-i18n-key="sidebar.members">{{ directT('sidebar.members') }}</span>
          </RouterLink>
        </div>
        <div
          class="accordion-item rounded-md text-black dark:text-white mb-[5px] whitespace-nowrap"
        >
          <button
            class="accordion-button toggle flex items-center transition-all py-[9px] ltr:pl-[14px] ltr:pr-[30px] rtl:pr-[14px] rtl:pl-[30px] rounded-md font-medium w-full relative hover:bg-gray-50 text-left dark:hover:bg-[#15203c]"
            type="button"
          >
            <i
              class="material-symbols-outlined transition-all text-gray-500 dark:text-gray-400 ltr:mr-[7px] rtl:ml-[7px] !text-[22px] leading-none relative -top-px"
            >
              settings
            </i>
            <span class="title leading-none" data-i18n-key="common.settings"> {{ directT('common.settings') }} </span>
          </button>
          <div class="accordion-collapse hidden">
            <div class="pt-[4px]">
              <ul class="sidebar-sub-menu">
                <li class="sidemenu-item mb-[4px] last:mb-0">
                  <RouterLink
                    to="/settings/account-settings"
                    class="sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]"
                    @click="handleNavigation"
                  >
                    <span data-i18n-key="sidebar.accountSettings">{{ directT('sidebar.accountSettings') }}</span>
                  </RouterLink>
                </li>
                <li class="sidemenu-item mb-[4px] last:mb-0">
                  <RouterLink
                    to="/settings/change-password"
                    class="sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]"
                    @click="handleNavigation"
                  >
                    <span data-i18n-key="sidebar.changePassword">{{ directT('sidebar.changePassword') }}</span>
                  </RouterLink>
                </li>
                <li class="sidemenu-item mb-[4px] last:mb-0">
                  <RouterLink
                    to="/settings/connections"
                    class="sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]"
                    @click="handleNavigation"
                  >
                    <span data-i18n-key="sidebar.connections">{{ directT('sidebar.connections') }}</span>
                  </RouterLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="absolute bottom-0 left-0 right-0 bg-white dark:bg-[#0c1427] pb-[15px] px-[25px]">
        <div
          class="accordion-item rounded-md text-black dark:text-white mb-[5px] whitespace-nowrap"
        >
          <RouterLink
            to="/authentication/logout"
            class="accordion-button flex items-center transition-all py-[9px] ltr:pl-[14px] ltr:pr-[30px] rtl:pr-[14px] rtl:pl-[30px] rounded-md font-medium w-full relative hover:bg-red-100 text-red-600 bg-red-50 dark:bg-[#2A1515] font-bold text-left dark:hover:bg-red-900/20 dark:text-red-500"
            style="color: #ff0000 !important;"
            @click="handleNavigation"
          >
            <i
              class="material-symbols-outlined transition-all ltr:mr-[7px] rtl:ml-[7px] !text-[22px] leading-none relative -top-px"
              style="color: #ff0000 !important;"
            >
              logout
            </i>
            <span class="title leading-none" style="color: #ff0000 !important;" data-i18n-key="common.logout"> {{ directT('common.logout') }} </span>
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Swipe edge indicator (only visible on mobile when sidebar is closed) -->
  <div 
    v-if="!stateStoreInstance.open && isMobile()"
    :class="[
      'swipe-indicator fixed top-1/2 -translate-y-1/2 z-[6] h-20 w-1.5 bg-primary-500/40 rounded-r-md transition-opacity',
      isRTL ? 'right-0' : 'left-0'
    ]"
  ></div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, onBeforeUnmount, computed, watch } from "vue";
import { RouterLink, useRouter } from "vue-router";
import stateStore from "@/utils/store";
import enTranslations from "@/i18n/locales/en.json";
import heTranslations from "@/i18n/locales/he.json";
import arTranslations from "@/i18n/locales/ar.json";
import { i18n } from "@/i18n";
import { useUserStore } from "@/store/user";
import emitter from "@/utils/emitter";

// Type definition for translation objects
type TranslationObject = {
  [key: string]: string | TranslationObject;
};

// Storage key for open menus in localStorage
const OPEN_MENUS_STORAGE_KEY = 'trezo-open-sidebar-menus';

export default defineComponent({
  name: "LeftSidebar",
  setup() {
    // Remove useI18n hook and use the global i18n instance directly
    const locale = computed(() => i18n.global.locale);
    const router = useRouter();
    const stateStoreInstance = stateStore;
    const sidebarRef = ref<HTMLElement | null>(null);
    const touchStartX = ref(0);
    const touchEndX = ref(0);
    const swipeThreshold = 50; // Minimum distance in pixels to trigger swipe
    const edgeThreshold = 30; // Maximum distance from edge to start swipe
    
    // מערך לשמירת תפריטים פתוחים
    const openMenus = ref<string[]>([]);
    
    // ייבוא ה-store של משתמש
    const userStore = useUserStore();
    
    // Check if RTL mode is active
    const isRTL = computed(() => document.documentElement.dir === 'rtl');

    // Translation files
    const translationFiles = {
      en: enTranslations,
      he: heTranslations,
      ar: arTranslations
    };

    // משתנים מחושבים לפי ההגדרות בארגון
    const shouldShowEcommerce = computed(() => userStore.organizationSettings.ecommerce === true);
    const shouldShowRealEstate = computed(() => userStore.organizationSettings.realestate === true);

    // משתנים מחושבים לתצוגת התפריט לפי הלוגיקה המבוקשת
    const shouldShowEcommerceDashboard = computed(() => {
      if (shouldShowRealEstate.value) return false;
      return shouldShowEcommerce.value;
    });

    const shouldShowCRMDashboard = computed(() => {
      if (shouldShowEcommerce.value) return false;
      return true; // תמיד מוצג אם ecommerce לא מופעל
    });

    const shouldShowEcommerceMenu = computed(() => {
      if (shouldShowRealEstate.value) return false;
      return shouldShowEcommerce.value;
    });

    const shouldShowCRMMenu = computed(() => {
      if (shouldShowEcommerce.value) return false;
      return true; // תמיד מוצג אם ecommerce לא מופעל
    });

    const shouldShowRealEstateMenu = computed(() => {
      if (shouldShowEcommerce.value) return false;
      return shouldShowRealEstate.value;
    });

    // Direct translation function that bypasses vue-i18n
    const directT = (key: string, params?: Record<string, string>): string => {
      const parts = key.split('.');
      // Extract the current locale properly from i18n
      let currentLocale;
      
      if (typeof locale.value === 'object' && locale.value !== null) {
        // Try to get locale from the locale object
        currentLocale = String(locale.value.value || 
                              locale.value.toString() || 
                              i18n.global.locale || 
                              localStorage.getItem('language') || 
                              'en');
      } else {
        currentLocale = String(locale.value);
      }
      
      // Validate that locale is supported, otherwise fallback to 'en'
      if (!['en', 'he', 'ar'].includes(currentLocale)) {
        currentLocale = 'en';
      }
      
      let result: TranslationObject = translationFiles[currentLocale as keyof typeof translationFiles] || translationFiles.en;
      
      for (const part of parts) {
        if (!result || !(part in result)) {
          console.warn(`Missing translation key: ${key} in ${currentLocale} locale`);
          // Fallback to English if translation not found
          let enResult: TranslationObject = translationFiles.en;
          for (const fallbackPart of parts) {
            if (!enResult || !(fallbackPart in enResult)) return key;
            enResult = enResult[fallbackPart as keyof typeof enResult] as TranslationObject;
          }
          return typeof enResult === 'string' ? enResult : key;
        }
        result = result[part as keyof typeof result] as TranslationObject;
      }
      
      // Handle parameter substitution for placeholders
      let translatedText = typeof result === 'string' ? result : key;
      
      if (params && typeof translatedText === 'string') {
        Object.entries(params).forEach(([paramName, paramValue]) => {
          translatedText = translatedText.replace(`{${paramName}}`, paramValue);
        });
      }
      
      return translatedText;
    };

    // Initialize accordion functionality
    const initializeAccordions = () => {
      console.log("Initializing accordions");
      
      // Get all accordion buttons
      const accordions = document.querySelectorAll<HTMLElement>(
        ".accordion-button.toggle, .sidemenu-link.toggle"
      );
      
      // Get all accordion menu titles for debugging
      const menuTitles = Array.from(accordions).map(
        acc => acc.querySelector('.title')?.textContent?.trim()
      );
      console.log("Current menu titles:", menuTitles);
      
      // בטל את האירועים מכל האקורדיונים  
      accordions.forEach((accordion) => {
        // כדי לבטל את האירועים הקודמים, נשכפל את האלמנט ללא האירועים שלו
        const clone = accordion.cloneNode(true) as HTMLElement;
        if (accordion.parentNode) {
          accordion.parentNode.replaceChild(clone, accordion);
        }
      });
      
      // Get the refreshed list after replacing elements
      const refreshedAccordions = document.querySelectorAll<HTMLElement>(
        ".accordion-button.toggle, .sidemenu-link.toggle"
      );
      
      // Get stored open menus from localStorage
      try {
        const savedOpenMenus = localStorage.getItem(OPEN_MENUS_STORAGE_KEY);
        const openMenusArray = savedOpenMenus ? JSON.parse(savedOpenMenus) : [];
        
        console.log("Saved open menus:", openMenusArray);
        
        // First open the saved menus based on their text content
        refreshedAccordions.forEach((accordion) => {
          const menuTitle = accordion.querySelector('.title')?.textContent?.trim();
          
          if (menuTitle && openMenusArray.includes(menuTitle)) {
            console.log("Opening saved menu:", menuTitle);
            
            // Open this accordion
            accordion.classList.add('open');
            
            // Find and show the panel
            const panel = accordion.nextElementSibling as HTMLElement;
            if (panel) {
              panel.style.display = 'block';
            }
          }
        });
      } catch (error) {
        console.error("Error restoring accordion state:", error);
        localStorage.removeItem(OPEN_MENUS_STORAGE_KEY);
      }
      
      // Now add click listeners to all accordions
      refreshedAccordions.forEach((accordion) => {
        accordion.addEventListener("click", function() {
          // Find all sibling accordions
          const siblings = Array.from(
            this.closest(".accordion-collapse")?.querySelectorAll<HTMLElement>(
              ".accordion-button.toggle, .sidemenu-link.toggle"
            ) || refreshedAccordions
          );
          
          // Close siblings
          siblings.forEach((sibling) => {
            if (sibling !== this) {
              sibling.classList.remove("open");
              const siblingPanel = sibling.nextElementSibling as HTMLElement;
              if (siblingPanel) {
                siblingPanel.style.display = "none";
              }
            }
          });
          
          // Toggle current accordion
          this.classList.toggle("open");
          const panel = this.nextElementSibling as HTMLElement;
          if (panel) {
            panel.style.display = this.classList.contains("open") ? "block" : "none";
          }
          
          // Save open accordion state to localStorage
          setTimeout(() => {
            const openAccordions = document.querySelectorAll<HTMLElement>(".accordion-button.toggle.open");
            const openMenuTitles = Array.from(openAccordions).map(
              acc => acc.querySelector('.title')?.textContent?.trim()
            ).filter(Boolean);
            
            console.log("Saving open menus:", openMenuTitles);
            localStorage.setItem(OPEN_MENUS_STORAGE_KEY, JSON.stringify(openMenuTitles));
          }, 0);
        });
      });
    };

    // Check if device is mobile (screen width < 1280px which is xl breakpoint)
    const isMobile = () => window.innerWidth < 1280;

    // Handle swipe gestures
    const handleTouchStart = (event: TouchEvent) => {
      touchStartX.value = event.touches[0].clientX;
    };

    const handleTouchMove = (event: TouchEvent) => {
      touchEndX.value = event.touches[0].clientX;
    };

    const handleTouchEnd = () => {
      if (!isMobile()) return;
      
      const swipeDistance = touchEndX.value - touchStartX.value;
      
      // If sidebar is closed: Open with swipe from edge
      if (!stateStoreInstance.open) {
        // For LTR: swipe right from left edge
        // For RTL: swipe left from right edge
        if (
          (!isRTL.value && swipeDistance > swipeThreshold && touchStartX.value < edgeThreshold) ||
          (isRTL.value && swipeDistance < -swipeThreshold && touchStartX.value > (window.innerWidth - edgeThreshold))
        ) {
          stateStoreInstance.onChange(); // Open the sidebar
        }
      } 
      // If sidebar is open: Close with swipe in opposite direction
      else {
        // For LTR: swipe left
        // For RTL: swipe right
        if (
          (!isRTL.value && swipeDistance < -swipeThreshold) ||
          (isRTL.value && swipeDistance > swipeThreshold)
        ) {
          stateStoreInstance.onChange(); // Close the sidebar
        }
      }
    };

    // Function to close sidebar when clicking outside
    const handleClickOutside = (event: MouseEvent) => {
      if (!isMobile() || !stateStoreInstance.open) return;
      
      const target = event.target as HTMLElement;
      const burgerMenuBtn = document.querySelector('.hide-sidebar-toggle');
      
      // Check if click is outside sidebar and not on the toggle button
      if (
        sidebarRef.value && 
        !sidebarRef.value.contains(target) && 
        burgerMenuBtn && 
        !burgerMenuBtn.contains(target)
      ) {
        stateStoreInstance.onChange();
      }
    };

    // Handler for navigation
    const handleNavigation = () => {
      if (isMobile() && stateStoreInstance.open) {
        stateStoreInstance.onChange();
      }
    };

    // Explicit function to close the sidebar
    const closeSidebar = () => {
      console.log("Close sidebar button clicked");
      stateStoreInstance.onChange();
    };

    // Listen for route changes
    router.afterEach(() => {
      if (isMobile() && stateStoreInstance.open) {
        stateStoreInstance.onChange();
      }
      
      // אתחול מחדש של התפריטים אחרי רענון עמוד או ניווט
      setTimeout(() => {
        initializeAccordions();
      }, 100);
    });

    // Listen for language change event
    const handleLanguageChange = (newLang: string) => {
      console.log(`LeftSidebar: Language changed to ${newLang}, reinitializing accordions`);
      
      // מחיקת מצב האקורדיונים המוקדם, במקרה שיש ניגוד עם השפה החדשה
      localStorage.removeItem(OPEN_MENUS_STORAGE_KEY);
      
      // עדכון ישיר של כל הכותרות בתפריט לפי המפתחות שלהן
      document.querySelectorAll<HTMLElement>('[data-i18n-key]').forEach(el => {
        const key = el.getAttribute('data-i18n-key');
        if (key) {
          console.log(`Updating element with key: ${key}`);
          el.textContent = directT(key);
          
          // גישה יזומה לתכונה כדי לכפות רענון
          const forceRepaint = el.offsetWidth;
        }
      });
      
      // חכה קצת זמן כדי שהתרגומים יתעדכנו בממשק
      setTimeout(() => {
        // קודם בטל את כל האירועים הקיימים
        document.querySelectorAll<HTMLElement>(
          ".accordion-button.toggle, .sidemenu-link.toggle"
        ).forEach((el) => {
          const clone = el.cloneNode(true) as HTMLElement;
          if (el.parentNode) {
            el.parentNode.replaceChild(clone, el);
          }
        });
        
        // רק אחר כך אתחל מחדש
        initializeAccordions();
      }, 250);
      
      // נסה שוב אחרי זמן ארוך יותר במקרה שהעדכון הראשון לא הספיק
      setTimeout(() => {
        // עדכון פעם נוספת את התרגומים
        document.querySelectorAll<HTMLElement>('[data-i18n-key]').forEach(el => {
          const key = el.getAttribute('data-i18n-key');
          if (key) {
            el.textContent = directT(key);
          }
        });
        
        initializeAccordions();
      }, 750);
    };

    onMounted(() => {
      document.addEventListener('click', handleClickOutside);
      document.addEventListener('touchstart', handleTouchStart);
      document.addEventListener('touchmove', handleTouchMove);
      document.addEventListener('touchend', handleTouchEnd);
      
      // ננסה לאתחל פעמיים עם טיימאאוט, פעם אחרי מיד ופעם אחרי 500ms
      initializeAccordions();
      setTimeout(() => {
        initializeAccordions();
      }, 500);
      
      // טעינת הגדרות הארגון בעת טעינת הקומפוננטה
      userStore.fetchOrganizationSettings();
      
      // Listen for app becoming active event to reinitialize accordions
      emitter.on('app:active', handleAppBecameActive);
      
      // Watch for language changes and reinitialize accordions
      watch(locale, (newLocale, oldLocale) => {
        console.log(`Language changed from ${oldLocale} to ${newLocale}, reinitializing accordions`);
        // Allow some time for Vue to update the DOM with new translations
        const newLocaleString = typeof newLocale === 'object' ? String(newLocale.value) : String(newLocale);
        handleLanguageChange(newLocaleString);
      });
      
      // Listen for language change event
      emitter.on('language:changed', handleLanguageChange);
    });

    onBeforeUnmount(() => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
      
      // Remove emitter listeners
      emitter.off('app:active', handleAppBecameActive);
      emitter.off('language:changed', handleLanguageChange);
    });
    
    // Handle when app becomes active after being in background
    const handleAppBecameActive = () => {
      console.log('LeftSidebar: App became active, reinitializing accordions');
      initializeAccordions();
    };

    return {
      stateStoreInstance,
      directT,
      shouldShowEcommerce,
      shouldShowRealEstate,
      shouldShowEcommerceDashboard,
      shouldShowCRMDashboard,
      shouldShowEcommerceMenu,
      shouldShowCRMMenu,
      shouldShowRealEstateMenu,
      sidebarRef,
      handleNavigation,
      isMobile,
      locale,
      isRTL,
      closeSidebar
    };
  },
});
</script>

<style scoped>
.swipe-indicator {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    opacity: 0.4;
  }
}
</style>
